module.exports = "/assets/data/71423e5c2497ed63fcefce84a877bd6a-KA13.data.json";